import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/companies_/$companyId')({
  staticData: { title: 'Company' },
  // Switching company only changes this param. TanStack Router keeps the same
  // page instance for that, so an open wizard or draft would submit the previous
  // company's state. Remount the layout, and the outlet under it, instead.
  remountDeps: ({ params }): string => params.companyId,
})
